import { useQuery } from '@tanstack/react-query';
import { getCouponService } from '../../../domains/coupon';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

interface Options {
  limit?: number;
  offset?: number;
}

export const useCouponsByPharmacy = (
  pharmacyId: number | string | null | undefined,
  { limit = 100, offset = 0 }: Options = {}
) => {
  return useQuery({
    queryKey: ['coupons-by-pharmacy', pharmacyId, { limit, offset }],
    enabled: pharmacyId != null && pharmacyId !== '',
    queryFn: async () => {
      const res = await getCouponService().getCouponsByPharmacyId(pharmacyId, { limit, offset });
      if (!isResultOk(res)) return { items: [], total: 0 };
      const items = res?.data?.items ?? [];
      const total = res?.data?.total ?? items.length;
      return { items, total };
    },
  });
};
